module.exports = __webpack_public_path__ + "static/media/wireless1.7457bab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/wireless1.png
// module id = 987
// module chunks = 0